module.exports = __webpack_public_path__ + "static/media/S-task07_adjMatrix.ce25fd21.png";